export default __webpack_public_path__ + "static/media/playspace-logo.41e5808a.svg";